const BORDER = "#1e2130";
const TEXT_PRIMARY = "#e8eaf0";
const TEXT_SECONDARY = "#5a5f7a";

interface TimelineItem { aksiyon: string; zaman: string; ikon: string; renk: string; sure?: string; basarili?: boolean; kayip?: boolean; }
interface Kullanici { id: number; adSoyad: string; telefon: string; telefonTam: string; kampanya: string; asama: number; toplamAsama: number; whatsapp: boolean; tarih: string; email: string; timeline: TimelineItem[]; }
interface Props { kullanici: Kullanici; onKapat: () => void; }

export default function KullaniciDetayModal({ kullanici, onKapat }: Props) {
  const tarihFormat = new Date(kullanici.tarih).toLocaleDateString("tr-TR", { day: "numeric", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit" });
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ backgroundColor: "rgba(0,0,0,0.75)" }} onClick={onKapat}>
      <div className="w-full max-w-3xl max-h-[90vh] overflow-hidden flex flex-col rounded-2xl" style={{ backgroundColor: "#141720", border: "1px solid #2a2d3a" }} onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-6 py-4" style={{ borderBottom: `1px solid ${BORDER}` }}>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ background: "linear-gradient(135deg,#7c3aed,#4f46e5)" }}>
              <span className="text-white text-sm font-bold">{kullanici.adSoyad.split(" ").map((n) => n[0]).join("")}</span>
            </div>
            <div>
              <p className="text-sm font-bold" style={{ color: TEXT_PRIMARY }}>{kullanici.adSoyad}</p>
              <p className="text-xs" style={{ color: TEXT_SECONDARY }}>Kullanıcı Detayı</p>
            </div>
          </div>
          <button onClick={onKapat} className="w-8 h-8 flex items-center justify-center rounded-lg cursor-pointer transition-colors" style={{ color: TEXT_SECONDARY }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#1e2130")} onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}>
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>
        <div className="flex flex-col md:flex-row flex-1 overflow-hidden">
          <div className="md:w-64 p-5 flex-shrink-0 overflow-y-auto space-y-4" style={{ borderRight: `1px solid ${BORDER}` }}>
            <div>
              <p className="text-xs font-semibold uppercase tracking-wide mb-3" style={{ color: TEXT_SECONDARY }}>Kullanıcı Bilgileri</p>
              <div className="space-y-2.5">
                {[{ ikon: "ri-phone-line", val: kullanici.telefonTam }, { ikon: "ri-mail-line", val: kullanici.email }, { ikon: "ri-calendar-line", val: tarihFormat }].map((item, i) => (
                  <div key={i} className="flex items-center gap-2">
                    <div className="w-7 h-7 flex items-center justify-center rounded-lg" style={{ backgroundColor: "#1e2130" }}>
                      <i className={`${item.ikon} text-sm`} style={{ color: TEXT_SECONDARY }}></i>
                    </div>
                    <p className="text-xs" style={{ color: "#c8cad8" }}>{item.val}</p>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <p className="text-xs font-semibold uppercase tracking-wide mb-2" style={{ color: TEXT_SECONDARY }}>Kampanya</p>
              <span className="text-xs font-medium px-2.5 py-1 rounded-full" style={{ backgroundColor: "rgba(124,58,237,0.15)", color: "#a78bfa" }}>{kullanici.kampanya}</span>
            </div>
            <div>
              <p className="text-xs font-semibold uppercase tracking-wide mb-2" style={{ color: TEXT_SECONDARY }}>Adım İlerlemesi</p>
              <div className="flex items-center gap-1 mb-1">
                {Array.from({ length: kullanici.toplamAsama }).map((_, i) => (
                  <div key={i} className="flex-1 h-1.5 rounded-full" style={{ backgroundColor: i < kullanici.asama ? "#7c3aed" : "#1e2130" }}></div>
                ))}
              </div>
              <p className="text-xs" style={{ color: TEXT_SECONDARY }}>{kullanici.asama}/{kullanici.toplamAsama} adım tamamlandı</p>
            </div>
            <div>
              <p className="text-xs font-semibold uppercase tracking-wide mb-2" style={{ color: TEXT_SECONDARY }}>Etiketler</p>
              <div className="flex flex-wrap gap-1.5">
                {kullanici.whatsapp && <span className="text-xs px-2 py-0.5 rounded-full font-medium" style={{ backgroundColor: "rgba(34,197,94,0.15)", color: "#22c55e" }}>WhatsApp Kullanıcısı</span>}
                {kullanici.asama >= 4 && <span className="text-xs px-2 py-0.5 rounded-full font-medium" style={{ backgroundColor: "rgba(245,158,11,0.15)", color: "#f59e0b" }}>Yüksek İlgi</span>}
                {kullanici.asama === kullanici.toplamAsama && <span className="text-xs px-2 py-0.5 rounded-full font-medium" style={{ backgroundColor: "rgba(16,185,129,0.15)", color: "#10b981" }}>Tamamladı</span>}
              </div>
            </div>
          </div>
          <div className="flex-1 p-5 overflow-y-auto">
            <p className="text-xs font-semibold uppercase tracking-wide mb-4" style={{ color: TEXT_SECONDARY }}>Adım Adım Hareketler</p>
            <div className="relative">
              <div className="absolute left-5 top-0 bottom-0 w-px" style={{ backgroundColor: "#1e2130" }}></div>
              <div className="space-y-4">
                {kullanici.timeline.map((item, i) => (
                  <div key={i} className="flex items-start gap-4 relative">
                    <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 z-10" style={{ backgroundColor: item.renk + "20", border: "2px solid #141720" }}>
                      <i className={`${item.ikon} text-sm`} style={{ color: item.renk }}></i>
                    </div>
                    <div className="flex-1 rounded-xl p-3" style={{
                      backgroundColor: item.basarili ? "rgba(16,185,129,0.08)" : item.kayip ? "rgba(239,68,68,0.08)" : "#1a1d28",
                      border: `1px solid ${item.basarili ? "rgba(16,185,129,0.2)" : item.kayip ? "rgba(239,68,68,0.2)" : "#1e2130"}`
                    }}>
                      <div className="flex items-start justify-between gap-2">
                        <p className="text-sm font-medium" style={{ color: item.basarili ? "#10b981" : item.kayip ? "#ef4444" : "#c8cad8" }}>{item.aksiyon}</p>
                        <div className="flex items-center gap-1.5 flex-shrink-0">
                          {item.basarili && <span className="w-5 h-5 flex items-center justify-center rounded-full" style={{ backgroundColor: "rgba(16,185,129,0.15)" }}><i className="ri-check-line text-xs" style={{ color: "#10b981" }}></i></span>}
                          {item.kayip && <span className="w-5 h-5 flex items-center justify-center rounded-full" style={{ backgroundColor: "rgba(239,68,68,0.15)" }}><i className="ri-close-line text-xs" style={{ color: "#ef4444" }}></i></span>}
                          <span className="text-xs" style={{ color: TEXT_SECONDARY }}>{item.zaman}</span>
                        </div>
                      </div>
                      {item.sure && <p className="text-xs mt-1" style={{ color: TEXT_SECONDARY }}><i className="ri-time-line mr-1"></i>{item.sure}</p>}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
